import React, { useRef } from "react";

import "../style/Video.scss";

const Video = (prop) => {
  const { videourl, caption, bg } = prop;
  const videoEl = useRef(null);

  return (
    <div className={bg}>
      <div className="video-element-box">
        <video
          controls={false}
          id="video-element"
          autoPlay={true}
          playsInline
          muted
          ref={videoEl}
          loop
        >
          <source
            src={process.env.PUBLIC_URL + "/" + videourl}
            type="video/mp4"
          />
        </video>
        <div className="video-caption">{caption}</div>
      </div>
    </div>
  );
};

export default Video;
